/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect } from 'react';
import {
  CustomCollapseCard,
  Text,
  AddCarTypeSkeleton,
  AddCarTitleTypeSkeleton,
} from '@src/components';
import { Radio, Button, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  incrementActiveStep,
  getCustomerVousList,
  resetCurrentLoadAddNewCarType,
  changeDemandNo,
  getVehicleDeviceTypeList,
  setSelectVehicleProviderType,
  setSelectCustomerVousList,
} from '@src/store/slice/addNewCarStore/addCarTypeSlice';
import AddCarSelectFuelProvider from './AddCarSelectFuelProvider';
import AddCarSelectType from './AddCarSelectType';
import { useLanguageChange } from '@src/hooks/useLanguageChange';
import '@src/styles/addNewCar/addCarType.scss';
import { warningDialog } from '@src/components/CustomDialog';
import iconDanger from '@src/assets/icons/danger.svg';
import CustomImage from '@src/components/CustomImage';

const AddCarType = () => {
  const [manuelAddCar, setManuelAddCar] = useState(1);
  const [value, setValue] = useState(1);
  const [demandNo, setDemandNo] = useState('');
  const { isAdmin } = useSelector((state) => state.auth);
  const {
    selectVehicleDeviceType,
    selectVehicleProviderType,
    customerVousList,
    vehicleDeviceTypeList,
    loading,
  } = useSelector((state) => state?.addCarType);
  const dispatch = useDispatch();
  const [loadingRadioGroup, setLoadingRadioGroup] = useState(false);

  useEffect(() => {
    setLoadingRadioGroup(true);
    setTimeout(() => {
      setLoadingRadioGroup(false);
      handleMasterOnlyPo();
    }, 300);
  }, []);

  useEffect(() => {
    if (customerVousList) {
      handleMasterOnlyPoFuelProvider();
    }
  }, [customerVousList]);

  useLanguageChange(() => {
    dispatch(getCustomerVousList());
  });

  const handleCarApproval = useCallback(async () => {
    console.log('step 1');
    if (selectVehicleDeviceType === 18) {
      warningDialog({
        title: (
          <div className="utts-modal-1-head">
            <span className="utts-modal-1-head-text" style={{ width: 440 }}>
              <Text t="importantReminderAboutUttsTransactions" />
            </span>
          </div>
        ),
        className: 'warningModal-utts',
        width: 590,
        onOk: () => goToNextStep(),
        htmlContent: (
          <div>
            <div className="utts-modal-1-area2">
              <CustomImage src={iconDanger} />
              <span
                className="utts-modal-1-area1-text"
                style={{ alignItems: 'center', marginTop: 5 }}
              >
                <Text t="withThisTransaction" />{' '}
                <b className="utts-bold">
                  <Text t="youAreAboutToAddANewVehicle" />
                </b>
              </span>
            </div>
            <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
              <span className="utts-modal-1-area1-text">
                <Text t="uttsApplicationPaymentAndAssemblyProcess" />{' '}
                <b className="utts-bold">
                  <Text t="outsideOfEdenred" />
                </b>{' '}
                <Text t="isCarriedOutThroughAuthorizedCompanies" />
              </span>
              <span className="utts-modal-1-area1-text" style={{ marginTop: 10 }}>
                <Text t="ifYourVehiclePreviously" />{' '}
                <b className="utts-bold">
                  <Text t="ifUttsDeviceTtbIsInstalled" />
                </b>{' '}
                <Text t="youCanStartPurchasingFuelWithThisDevice" />
              </span>
              <span className="utts-modal-1-area1-text" style={{ marginTop: 10 }}>
                <Text t="notYet" />{' '}
                <b className="utts-bold">
                  <Text t="ifAssemblyHasNotBeenDone" />
                </b>
              </span>
              <span className="utts-modal-1-area1-text">
                <span style={{ color: '#006cfa', fontSize: 16 }}>· </span>
                <a
                  href="https://www.utts.gov.tr/"
                  style={{ color: '#006cfa', textDecoration: 'underline' }}
                  target="_blank"
                >
                  {' '}
                  www.utts.gov.tr
                </a>{' '}
                <Text t="youCanApplyFromTheAddress" />
              </span>
              <span className="utts-modal-1-area1-text">
                <span style={{ color: '#006cfa', fontSize: 16 }}>· </span>
                <Text t="youCanCompleteTheAssemblyProcessByReviewing" />
              </span>
            </div>
          </div>
        ),
      });
    } else {
      goToNextStep();
    }
  }, [dispatch, demandNo, selectVehicleDeviceType]);

  const goToNextStep = () => {
    if (isAdmin && changeDemandNo) {
      dispatch(changeDemandNo(demandNo));
    }
    dispatch(incrementActiveStep());
  };

  const handleMasterOnlyPo = async () => {
    await dispatch(getCustomerVousList());
    setManuelAddCar(2);
  };

  const handleAddManuelCarChanged = async (e) => {
    console.log('e', e.target.value);
    setValue(e.target.value);
    setManuelAddCar(1);
    await dispatch(resetCurrentLoadAddNewCarType());
    if (e.target.value === 2) {
      await dispatch(getCustomerVousList());
      setManuelAddCar(2);
    }
  };

  const handleMasterOnlyPoFuelProvider = async () => {
    const newValue = selectVehicleProviderType || 4;
    const selectCustomerVousList = customerVousList.find((list) => list.vouId === newValue);
    await dispatch(
      getVehicleDeviceTypeList({
        customerId: customerVousList[0]?.customerId,
        vouId: newValue,
      }),
    );
    await dispatch(setSelectVehicleProviderType(newValue));
    await dispatch(setSelectCustomerVousList(selectCustomerVousList));
  };

  return (
    <div data-testid="add-car-type-collapse">
      {/*loadingRadioGroup ? (
        <AddCarTitleTypeSkeleton />
      ) : (
        <CustomCollapseCard
          data-testid="add-car-type-collapse"
          className="order-type-card order-input-form-page"
          bodyCenter
          cardTitle={<Text t="carAddTypeTitle" />}
          cardTitleAlign="center"
        >
          <div className="order-type-container" style={{ backgroundColor: '#e9ecef' }}>
            <div className="card-checkbox-content">
              <Radio.Group
                id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radioGroup"
                onChange={handleAddManuelCarChanged}
                value={value}
                className="custom-radio-input-credit-card order-balance-type-radio"
                aria-label={value}
              >
                <div className="row justify-content-center">
                  <Radio
                    id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio2"
                    value={2}
                  >
                    <div className="card-label">
                      <Text t="manualAddCar" />
                    </div>
                  </Radio>
                  <Radio
                    id="ticketRestaurant-balanceUpload-balanceInformation-orderType-radio3"
                    value={3}
                  >
                    <div className="card-label">
                      <Text t="carUploadWithExcel" />
                    </div>
                  </Radio>
                </div>
              </Radio.Group>
            </div>
          </div>
        </CustomCollapseCard>
      )*/}
      {/*loading.customerVousList ? (
        <AddCarTypeSkeleton />
      ) : (
        manuelAddCar === 2 && <AddCarSelectFuelProvider customerVousList={customerVousList} />
      )*/}
      {loading.vehicleDeviceTypeList ? (
        <AddCarTypeSkeleton padding="25px 10px" />
      ) : (
        manuelAddCar === 2 &&
        vehicleDeviceTypeList &&
        vehicleDeviceTypeList.length > 0 && (
          <AddCarSelectType vehicleDeviceTypeList={vehicleDeviceTypeList} />
        )
      )}
      {manuelAddCar === 2 &&
        selectVehicleDeviceType !== null &&
        (isAdmin ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: 5,
              marginBottom: 20,
              marginTop: 20,
            }}
          >
            <h3 className="customer-demand-no-text">
              <Text t="requestNo" />
            </h3>
            <h3 className="customer-demand-no-text" style={{ color: '#f72717' }}>
              *
            </h3>
            <Input
              id="adminAddNewCarCustomerDemandNo"
              name="adminAddNewCarCustomerDemandNo"
              type="numeric"
              placeholder="Talep no giriniz"
              className="custom-admin-demand-no"
              value={demandNo}
              onChange={(e) => {
                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                setDemandNo(numericValue);
              }}
            />
            <button
              className="customer-demand-no-button"
              onClick={() => (demandNo?.length > 0 ? handleCarApproval() : null)}
              style={{
                cursor: demandNo?.length > 0 ? 'pointer' : 'not-allowed',
                backgroundColor: demandNo?.length > 0 ? '#f66301' : '#d1d1d1',
              }}
            >
              <Text t="continue" />
            </button>
          </div>
        ) : (
          <div className="step-btn-container" style={{ marginTop: '30px' }}>
            <Button
              id="add-new-car-container-next-btn"
              className="next-btn"
              onClick={handleCarApproval}
            >
              <Text t="continue" />
            </Button>
          </div>
        ))}
    </div>
  );
};
export default AddCarType;
